/**
 * Reads the Google Analytics client id from the analytics.js global, mirroring
 * the Ember login (`getGoogleAnalyticsClientID`). The login authenticators
 * require a `ga_client_id` string; when GA hasn't loaded we send an empty
 * string rather than failing the login.
 */
export function getGaClientId(): string {
  return window.ga?.getAll?.()?.[0]?.get('clientId') ?? '';
}
